import StonlyGuides from '../enums/StonlyGuides'

export function useStonlyWelcomeGuide() {
  return StonlyGuides.BUSINESS_PLAN
}
